import {normalizeDecimalSeparator} from './number';

/**
 * Checks if the given input exists in the possible values array
 * @param {string} inputString
 * @param {string[]} possibleValues
 * @return {boolean}
 */
const containsPossibleValue = (inputString, possibleValues) => {
    return possibleValues.some((v) => inputString?.toLowerCase().includes(v.toLowerCase()));
};

/**
 * Checks if the given input exists in the possible values array
 * @param {{value: string, label: string}} conditionType
 * @return {{amount: boolean, perUnit: boolean, percentage: boolean}}
 */
export const getEnabledFieldsByConditionType = (conditionType) => {
    if (!conditionType || conditionType?.label?.toLowerCase() === 'no options') {
        return {amount: false, perUnit: false, percentage: false};
    };
    const amountPossibleValues = ['val', 'fee', 'charges', 'insurance customs'];
    const quantityPossibleValues = ['quanti', 'qty', 'pallets'];
    const percentagePossibleValues = ['%'];
    // check for percentage
    const isPercentage = containsPossibleValue(conditionType?.label, percentagePossibleValues);
    const isPerUnit = containsPossibleValue(conditionType?.label, quantityPossibleValues);
    let isAmount = isPerUnit ? isPerUnit : containsPossibleValue(conditionType?.label, amountPossibleValues);

    // default case
    if (!isPercentage && !isPerUnit && !isAmount) {
        isAmount = true;
    }
    return {amount: isAmount, perUnit: isPerUnit, percentage: isPercentage};
};

/**
 * Gets the total conditions values from the material
 * @param {Material} material
 * @return {number}
 */
export const getTotalValueOfConditions = (material) => {
    return material.transportCostConditions.reduce((s, condition) => {
        const enabledFields = getEnabledFieldsByConditionType(condition.conditionType);
        if (enabledFields.perUnit && condition.amount && condition.perUnit && material) {
            return s + (Number(material.quantity) / Number(condition.perUnit) * Number(normalizeDecimalSeparator(condition.amount)) * Number(condition.currencyExchangeRate));
        }
        if (enabledFields.amount && condition.amount) {
            return s + (Number(normalizeDecimalSeparator(condition.amount)) * Number(condition.currencyExchangeRate));
        }
        if (enabledFields.percentage && condition.percentage && material) {
            return s + (((material.price * material.quantity) / 100) * Number(condition.percentage) * Number(condition.currencyExchangeRate));
        }
    }, 0);
};

/**
 * Gets the total condition value without formating
 * @param {Material} material
 * @param {object} condition
 * @return {number}
 */
export const calculateTotalValueOfCondition = (material, condition)=>{
    if (!condition) return 0;

    const enabledFields = getEnabledFieldsByConditionType(condition.conditionType);
    if (enabledFields.perUnit && condition.amount && condition.perUnit && material) {
        return (Number(material.quantity) / Number(condition.perUnit)) * Number(normalizeDecimalSeparator(condition.amount)) * Number(condition.currencyExchangeRate);
    }
    if (enabledFields.amount && condition.amount) {
        return Number(normalizeDecimalSeparator(condition.amount)) * Number(condition.currencyExchangeRate);
    }
    if (enabledFields.percentage && condition.percentage && material) {
        return ((material.price * material.quantity) / 100) * Number(condition.percentage) * Number(condition.currencyExchangeRate);
    }
    return 0;
};
